import { useRef } from 'react'

import { motion, useAnimation, useInView } from 'framer-motion'

import { cn } from '@/shared/lib/utils'

interface BackgroundPatternColumnProps {
  images: Array<{
    src: string
    className?: string
  }>
  direction: 'left' | 'right'
  className?: string
  offset?: number // offset em pixels para posicionamento dinâmico
  cycleIndex?: number // índice do ciclo para alternar imagens da direita
}

export const BackgroundPatternColumn = ({
  images,
  direction,
  className,
  offset = 0,
}: BackgroundPatternColumnProps) => {


  // Cada bloco deve ter exatamente 1920px (2 ciclos de 960px)
  const BLOCK_HEIGHT = 1920

  return (
    <div
      className={cn(
        'absolute flex flex-col justify-start gap-0 pointer-events-none select-none w-full',
        direction === 'left' ? 'left-0' : 'right-0',
        className
      )}
      style={{
        top: `${offset}px`,
        height: `${BLOCK_HEIGHT}px` // Garante altura exata de 1920px
      }}
    >
      {images.map((img, idx) => (
        <BackgroundPatternImage
          src={img.src}
          key={idx}
          direction={direction}
          className={cn('pointer-events-none select-none', img.className)}
        />
      ))}
    </div>
  )
}

export const BackgroundPatternImage = ({
  src,
  direction,
  className
}: {
  src: string
  direction: 'left' | 'right'
  className?: string
}) => {
  const ref = useRef(null)
  const isInView = useInView(ref, { margin: '-10% 0px -10% 0px', once: true })
  const controls = useAnimation()

  if (isInView) {
    controls.start({
      x: 0,
      opacity: 1,
      transition: { type: 'spring', stiffness: 60, damping: 18 }
    })
  }

  return (
    <motion.img
      ref={ref}
      src={src}
      alt=""
      className={cn('w-full', className)}
      initial={{
        x: direction === 'left' ? -80 : 80,
        opacity: 0
      }}
      animate={controls}
    />
  )
}
